import * as React from "react";
import { forwardRef } from "react";
const SvgCircleEmpty = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8.5, r: 7.5, stroke: "#C3C3C3" }));
const ForwardRef = forwardRef(SvgCircleEmpty);
export default ForwardRef;
